import { logger } from '../utils/logger';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app/store';
import {
    isLoading,
    loadData,
    loadList,
    documentoHabilitacionInitial,
} from '../context/DocumentoHabilitacion/DocumentoHabilitacionReducer';
import { DocumentoHabilitacion } from '../types/DocumentoHabilitacion';
import { findAll, get, remove, uploadFile, downloadFile, downloadAndOpenFile } from '../services/Service';
import { Documento } from '../types/Documento';

export const useDocumentoHabilitacion = () => {
    const BASE_URL = 'documentos-habilitacion';

    const { documentos, documentoSelected, loading } = useSelector(
        (state: RootState) => state.documentoHabilitacion
    );
    const dispatch = useDispatch();

    const buscarDocumentosByIdHabilitacion = async (id: number) => {
        dispatch(isLoading(true));
        await findAll(`${BASE_URL}/habilitacion/${id}`)
            .then((response) => {
                const filtrado = (response.data as DocumentoHabilitacion[])
                    .filter((d) => d.idHabilitacionContratista === id && d.vigente !== false);
                dispatch(loadList(filtrado));
            })
            .catch((error) => {
                logger.log(error);
                dispatch(loadList([]));
            });
    };

    const buscarDocumento = async (id: string) => {
        await get(BASE_URL, id)
            .then((response) => {
                dispatch(loadData(response.data));
            })
            .catch((error) => {
                logger.log(error);
            });
    };

    const deleteDocumento = async (id: string) => {
        try {
            await remove(BASE_URL, id);
            return true;
        } catch (error) {
            logger.log(error);
            return false;
        }
    };

    const subirDocumento = (file: File, params: any, mostrarMsj = true) =>
        uploadFile(`${BASE_URL}/subirArchivo`, file, params, mostrarMsj);

    const visualizarDocumento = <T extends Documento>(doc: T) =>
        downloadAndOpenFile(`${BASE_URL}/visualizarArchivo`, doc);

    const descargarDocumento = <T extends Documento>(doc: T) =>
        downloadFile(`${BASE_URL}/descargarArchivo`, doc);

    const handleDocumentoSelected = (documento: DocumentoHabilitacion) => {
        dispatch(loadData(documento));
    };

    const handleLoading = (load: boolean) => {
        dispatch(isLoading(load));
    };

    return {
        documentos,
        documentoSelected,
        loading,
        documentoHabilitacionInitial,
        buscarDocumentosByIdHabilitacion,
        buscarDocumento,
        deleteDocumento,
        subirDocumento,
        visualizarDocumento,
        descargarDocumento,
        handleDocumentoSelected,
        handleLoading,
    };
};
